import { Component } from 'react';
import _ from 'lodash';
import React from 'react';
import sc from 'styled-components';
import { Modal, Row, Col, Icon } from 'antd';
import StyledButton from './StyledButton';
import SoundsLikePhraseObject from '../store/models/SoundsLikePhraseObject';
import Input from './InputBouncy';
import Ellipsed from './Ellipsed';
import { GRAY } from './styleConstants';

const List = sc.div`
display: flex;
flex-direction: row;
align-items: center;
justify-content: flex-start;
max-with: 350px;
width: ${({ size }) => (size === 'small' ? '200px' : '100%')};
`;

const ModalList = sc.div`
height: 30vh;
overflow-y: scroll;
overflow-x: hide;
`;

const Danger = sc.span`
  font-style: italic;
`;

const CannotSoundsLike = () => <Danger>Multi-word Term</Danger>;

export default class ListEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      list: SoundsLikePhraseObject.toList(_.get(props, 'list', '')),
    };
  }

  get showModal() {
    return () => this.setState({ show: true });
  }

  update(id, soundsLike) {
    this.setState({
      list: SoundsLikePhraseObject.toList(this.state.list.map((p) => {
        if (p.id === id) {
          // eslint-disable-next-line no-param-reassign
          p.soundsLike = soundsLike;
        }
        return p;
      })),
    });
  }

  get saveList() {
    return () => {
      if (this.props.onChange) {
        this.props.onChange(this.state.list);
      }
      this.setState({ show: false });
    };
  }

  get cancelSave() {
    return () => this.setState({
      show: false,
      list: SoundsLikePhraseObject.toList(_.get(this, 'props.list', '')),
    });
  }

  delete(id) {
    this.setState({
      list: SoundsLikePhraseObject.toList(this.state.list.filter(p => p.id !== id)),
    });
  }

  get hasPhrases() {
    const list = _.get(this, 'state.list');

    for (let i = 0; i < list.length; i += 1) {
      if (!list[i].empty) {
        return true;
      }
    }
    return false;
  }

  get phrases() {
    return _.get(this, 'state.list', [])
      .map((sl) => {
        if (!(sl instanceof SoundsLikePhraseObject)) {
          return '';
        }
        return sl.soundsLike;
      })
      .filter(a => a);
  }

  get clearAll() {
    return () => {
      this.setState(
        { list: SoundsLikePhraseObject.toList([]) },
        this.saveList,
      );
    };
  }

  get canSoundsLike() {
    const { empty, term } = this.props;
    const termString = _.isString(term) ? term : '';

    if (empty || !termString) {
      return true;
    }
    return !/\w[\s]+\w/.test(termString);
  }

  render() {
    const { show, list } = this.state;

    return (
      <List size={this.props.size}>
        <Modal
          visible={show}
          onOk={this.saveList}
          title="Sounds Like Terms"
          onCancel={this.cancelSave}
        >
          <ModalList>
            {list.map(phrase => (
              <Row key={phrase.id}>
                <Col span={18}>
                  <Input
                    value={phrase.soundsLike}
                    onChange={e => this.update(phrase.id, e.target.value)}
                  />
                </Col>
                <Col span={2}>
                  <StyledButton
                    icon="delete"
                    size="small"
                    tabIndex="-1"
                    onClick={() => this.delete(phrase.id)}
                    style={({ display: phrase.empty ? 'none' : 'block' })}
                  />
                </Col>
                <Col span={2} title={!phrase.empty && phrase.isBad ? phrase.isBad : ''}>
                  {phrase.isBad && <Icon
                    type="exclamation-circle"
                    theme="twoTone"
                    size="small"
                    tabIndex="-1"
                    twoToneColor="#990000"
                  />}
                </Col>
              </Row>
            ))}
          </ModalList>
        </Modal>
        <StyledButton
          icon={this.canSoundsLike ? 'edit' : 'stop'}
          disabled={!this.canSoundsLike}
          size="small"
          onClick={this.showModal}
          style={({ marginRight: '1rem' })}
        />
        <Ellipsed style={({ flexGrow: 1 })}>
          {this.canSoundsLike ? this.phrases.join(', ') : <CannotSoundsLike />}
        </Ellipsed>
      </List>
    );
  }
}
